import { create } from 'zustand'
import type { DashboardSnapshot, LiveEvent } from '@/data/types'

/** Událost ze živého proudu, než ji potvrdí snapshot ze skladu. */
export interface LiveActivityItem {
  id: string
  eventName: string
  venueId: string
  venueName: string
  status: string
  integration: string
  at: string
}

interface DashboardState {
  snapshot: DashboardSnapshot | null
  feed: LiveEvent[]
  /** Předběžné události z SSE. Snapshot je autoritativní a tyhle nahradí. */
  liveActivity: LiveActivityItem[]
  bumpCounter: number
  setSnapshot: (s: DashboardSnapshot) => void
  pushEvent: (e: LiveEvent) => void
  pushLiveActivity: (item: LiveActivityItem) => void
  bump: () => void
}

const FEED_CAP = 50
const LIVE_CAP = 30

export const useDashboardStore = create<DashboardState>((set) => ({
  snapshot: null,
  feed: [],
  liveActivity: [],
  bumpCounter: 0,
  setSnapshot(snapshot) {
    set((state) => {
      // Co už dorazilo ve snapshotu, nemusíme držet v předběžném seznamu —
      // tím se případný rozdíl mezi oběma cestami sám srovná.
      const confirmed = new Set(snapshot.recentActivity.map((a) => a.id))
      return {
        snapshot,
        bumpCounter: 0,
        liveActivity: state.liveActivity.filter((a) => !confirmed.has(a.id)),
      }
    })
  },
  pushLiveActivity(item) {
    set((state) => {
      if (state.liveActivity.some((a) => a.id === item.id)) return state
      return {
        liveActivity: [item, ...state.liveActivity].slice(0, LIVE_CAP),
        bumpCounter: state.bumpCounter + 1,
      }
    })
  },
  pushEvent(event) {
    set((state) => ({
      feed: [event, ...state.feed].slice(0, FEED_CAP),
      bumpCounter: state.bumpCounter + 1,
    }))
  },
  bump() {
    set((state) => ({ bumpCounter: state.bumpCounter + 1 }))
  },
}))
